import React from 'react';
import { Button, Modal, Typography } from '@decub8/ui';

type Props = {
    show: boolean;
    onClose: () => void;
    onConfirmSubmit: () => void;
};

const OnboardingConfirmationSubmit: React.FC<Props> = ({
    show,
    onClose,
    onConfirmSubmit,
}) => (
    <Modal noClose show={show} onClose={onClose}>
        <Typography className="mb-4" allBold size="3xl">
            Are you ready to submit?
        </Typography>
        <Typography className="mb-8" variant="secondary">
            Once submitted, you won't be able to change your answers.
        </Typography>

        <div className="flex justify-between gap-4">
            <Button className="btn-primary w-full" onClick={onConfirmSubmit}>
                Submit
            </Button>
            <Button
                variant="custom"
                className="w-full bg-surface-level-three text-secondary"
                onClick={onClose}
            >
                Cancel
            </Button>
        </div>
    </Modal>
);

export default OnboardingConfirmationSubmit;
